import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/auth/login/login.component';
import { CantabAddComponent } from './components/cantab/cantab-add/cantab-add.component';
import { CantabAudioComponent } from './components/cantab/cantab-audio/cantab-audio.component';
import { CantabEditComponent } from './components/cantab/cantab-edit/cantab-edit.component';
import { CantabViewComponent } from './components/cantab/cantab-view/cantab-view.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DccsAddComponent } from './components/dccs/dccs-add/dccs-add.component';
import { DccsEditComponent } from './components/dccs/dccs-edit/dccs-edit.component';
import { DccsViewComponent } from './components/dccs/dccs-view/dccs-view.component';
import { ImageEditComponent } from './components/image/image-edit/image-edit.component';
import { ImageViewComponent } from './components/image/image-view/image-view.component';
import { InfoAddComponent } from './components/info/info-add/info-add.component';
import { InfoEditComponent } from './components/info/info-edit/info-edit.component';
import { InfoViewComponent } from './components/info/info-view/info-view.component';
import { MemberViewComponent } from './components/member/member-view/member-view.component';
import { MenuAddComponent } from './components/menu/menu-add/menu-add.component';
import { MenuEditComponent } from './components/menu/menu-edit/menu-edit.component';
import { MenuViewComponent } from './components/menu/menu-view/menu-view.component';
import { ReportComponent } from './components/report/report.component';
import { StroopAddComponent } from './components/stroop/stroop-add/stroop-add.component';
import { StroopEditComponent } from './components/stroop/stroop-edit/stroop-edit.component';
import { StroopViewComponent } from './components/stroop/stroop-view/stroop-view.component';
import { UserAddComponent } from './components/user/user-add/user-add.component';
import { UserEditComponent } from './components/user/user-edit/user-edit.component';
import { UserViewComponent } from './components/user/user-view/user-view.component';
import { WppsiAddComponent } from './components/wppsi/wppsi-add/wppsi-add.component';
import { WppsiEditComponent } from './components/wppsi/wppsi-edit/wppsi-edit.component';
import { WppsiViewComponent } from './components/wppsi/wppsi-view/wppsi-view.component';
import { AfterLoginGuard, BeforeLoginGuard, CanDeactivateGuard } from './services/guard.service';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';

const routes: Routes = [
    { path: '', redirectTo: '/dashboard', pathMatch: 'full', data: { title: 'Home' } },
    { path: 'login', component: LoginComponent, canActivate: [BeforeLoginGuard], data: { title: 'Login' } },
    { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [BeforeLoginGuard], data: { title: 'Forgot Password' } },
    { path: 'reset-password/:key', component: ResetPasswordComponent, canActivate: [BeforeLoginGuard], data: { title: 'Reset Password' } },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AfterLoginGuard], data: { title: 'Dashboard' } },
    {
        path: 'menu', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: MenuViewComponent, data: { title: 'Menu Navigation' } },
            { path: 'add', component: MenuAddComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Add Menu' } },
            { path: 'edit/:id', component: MenuEditComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Edit Menu' } }
        ]
    },
    {
        path: 'users', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: UserViewComponent, data: { title: 'Admins' } },
            { path: 'add', component: UserAddComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Add Admin' } },
            { path: 'edit/:id', component: UserEditComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Edit Admin' } }
        ]
    },
    {
        path: 'members', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: MemberViewComponent, data: { title: 'Participants' } }
        ]
    },
    {
        path: 'reports', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: ReportComponent, data: { title: 'Report' } },
        ]
    },
    {
        path: 'dccs', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: DccsViewComponent, data: { title: 'DCCS' } },
            { path: 'add', component: DccsAddComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Add DCCS' } },
            { path: 'edit/:id', component: DccsEditComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Edit DCCS' } },
        ]
    },
    {
        path: 'stroop', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: StroopViewComponent, data: { title: 'STROOP Test' } },
            { path: 'add', component: StroopAddComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Add STROOP Test' } },
            { path: 'edit/:id', component: StroopEditComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Edit STROOP Test' } },
        ]
    },
    {
        path: 'infos', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: InfoViewComponent, data: { title: 'Setting Quiz Info' } },
            { path: 'add', component: InfoAddComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Add quiz info' } },
            { path: 'edit/:id', component: InfoEditComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Edit quiz info' } },
        ]
    },
    {
        path: 'cantab', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: CantabViewComponent, data: { title: 'CANTAB Test' } },
            { path: 'add', component: CantabAddComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Add CANTAB Test' } },
            { path: 'edit/:id', component: CantabEditComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Edit CANTAB Test' } },
            { path: 'audio', component: CantabAudioComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Set CANTAB Backsound' } },
        ]
    },
    {
        path: 'wppsi', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: WppsiViewComponent, data: { title: 'WPPSI' } },
            { path: 'add', component: WppsiAddComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Add WPPSI' } },
            { path: 'edit/:id', component: WppsiEditComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Edit WPPSI' } },
        ]
    },
    {
        path: 'quiz-images', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: ImageViewComponent, data: { title: 'Setting Quiz Graphic' } },
            { path: 'edit/:id', component: ImageEditComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Edit quiz graphic' } },
        ]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
